import React from 'react';

export const formatDateToUserTimezone = (gmtDate) => {
  // 1. Check if the input exists at all
  if (!gmtDate || typeof gmtDate !== 'string') {
    return 'Invalid Date'; // or return null/empty string depending on your UI needs
  }

  // 2. Parse the GMT date string
  const dateParts = gmtDate.split(/[- :]/);
  
  // Basic check: Ensure we have enough parts to make a date (Year, Month, Day)
  if (dateParts.length < 3) {
    return 'Invalid Format';
  }

  const date = new Date(Date.UTC(
    dateParts[0], 
    dateParts[1] - 1, 
    dateParts[2], 
    dateParts[3] || 0, 
    dateParts[4] || 0, 
    dateParts[5] || 0
  ));

  // 3. Check if the resulting Date object is valid
  // getTime() returns NaN if the date is "Invalid Date"
  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  // 4. Format the date
  try {
    return date.toLocaleString(undefined, {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      hour12: true,
      hour: 'numeric',
      minute: 'numeric',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  } catch (error) {
    console.error("Formatting error:", error);
    return 'Formatting Error';
  }
};